import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CrawlLinks } from './crawl_links'
import { Item, Unit } from '../types'
import { tagsRepository } from '../repositories/tags_repository'
import {
  NamedItem,
  contextLinkGroups,
  deepestCategory,
  localizedName,
  unitLinks,
} from '../lib/internal_links'

type Props = Readonly<{
  item: Item
  units: readonly Unit[]
}>

const CardContextLinks = ({ item, units }: Props) => {
  const { t, i18n } = useTranslation()
  const [related, setRelated] = useState<NamedItem[]>([])
  const [illustratorCards, setIllustratorCards] = useState<NamedItem[]>([])
  const categoryId = deepestCategory(item.tags)?.id
  const illustratorId = item.tags.find(tag => tag.type === 'Illustrator')?.id

  useEffect(() => {
    if (!categoryId) {
      setRelated([])
      return
    }

    let cancelled = false

    tagsRepository
      .getItems(categoryId, { page: 1, types: [], limit: 24 })
      .then(({ items }) => {
        if (!cancelled) setRelated(items as NamedItem[])
      })
      .catch(() => {
        if (!cancelled) setRelated([])
      })

    return () => {
      cancelled = true
    }
  }, [categoryId])

  useEffect(() => {
    if (!illustratorId) {
      setIllustratorCards([])
      return
    }

    let cancelled = false

    tagsRepository
      .getItems(illustratorId, { page: 1, types: [], limit: 12 })
      .then(({ items }) => {
        if (!cancelled) setIllustratorCards(items as NamedItem[])
      })
      .catch(() => {
        if (!cancelled) setIllustratorCards([])
      })

    return () => {
      cancelled = true
    }
  }, [illustratorId])

  const groups = contextLinkGroups({
    item,
    language: i18n.language,
    related,
    illustratorCards,
  })
  const itemName = localizedName(item, i18n.language)

  return (
    <>
      <CrawlLinks label={ t('links.same_set') } heading={ t('links.same_set') } links={ groups.sameSet } />
      <CrawlLinks label={ t('links.same_illustrator') } heading={ t('links.same_illustrator') } links={ [...groups.illustrators, ...groups.illustratorCards] } />
      <CrawlLinks label={ t('links.characters') } heading={ t('links.characters') } links={ groups.characters } />
      <CrawlLinks label={ t('links.for_sale') } heading={ t('links.for_sale') } links={ unitLinks(units, itemName) } />
    </>
  )
}

export { CardContextLinks }
